import { PapiDaUserProfileModuleExhibitionistConfig } from '@wix/da-types-papi';

export interface Modules {
  [moduleId: number]: any;
}

export enum ModuleType {
  ABOUT = 'about',
  BADGES_ACTIVITY = 'badges_activity',
  COMMENTS = 'comments',
  COMMISSIONS = 'commissions',
  COVER_DEVIATION = 'cover_deviation',
  FEATURED_DEVIATION = 'featured_deviation',
  CUSTOM = 'papi_custombox',
  DONATIONS = 'donations',
  DEVIOUSNESS = 'deviousness',
  DRAFTS = 'drafts',
  EXHIBITIONIST = 'exhibitionist',
  FEATURED_DEVIATIONS = 'featured',
  FEATURED_JOURNALS = 'featured_journals',
  FEED = 'feed',
  FEED_PINNED_DEVIATION = 'feed_pinned_deviation',
  FOLDERS = 'folders',
  FOLDER_DEVIATIONS = 'folder_deviations',
  GROUPS_ADMIN = 'group_list_admins',
  GROUPS_MEMBER = 'group_list_members',
  JOURNALS = 'journals',
  LATEST_DEVIATIONS = 'latest_deviation',
  MY_COMMENTS = 'my_comments',
  NEWEST_DEVIATIONS = 'newest',
  POLLS = 'polls',
  PREMIUM_CONTENT = 'premium_content',
  PRINTS = 'prints',
  STATS = 'userstats',
  STATUSES = 'statuses',
  VISITORS = 'visitors',
  WATCHERS = 'watchers',
  WATCHING = 'watching',
}

export type ExhibitionistModuleConfig = PapiDaUserProfileModuleExhibitionistConfig;

export enum ExhibitionistViewMode {
  TORPEDO = 'torpedo',
  SLIDESHOW = 'slideshow',
}

export enum ExhibitionistSlideFitMode {
  FIT = 'fit',
  COVER = 'cover',
}
